export const BASE_URL = 'https://www.mtsbank.ru'
export const ICON_STORAGE_PREFIX = '/cyber/icons/'
